<template>
  <div>
    <div
      class="collection-container"
      v-if="slideshows.length > 0"
      v-on:click="editSelection(slideshow)"
      v-for="slideshow in slideshows"
      v-bind:key="slideshow.id">
        <div
          class="collection"
          v-bind:style="{ 'background-image': 'url(' + slideshow.slides[0].preview_image + '), url(' + slideshow.slides[0].image + '), url(https://powerslide-images.s3.amazonaws.com/placeholder.svg)' }" >
        </div>

        <div class="collection-title">
          {{slideshow.name}}
        </div>
    </div>

    <div class="new-slideshow" v-on:click="newSlideshow()">
      <div class="new-slideshow-title">
        Create a New Slideshow
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'

export default {
  name: 'SlideshowList',

  data () {
    return {
      slideshows: []
    }
  },

  methods: {
    editSelection: function (slideshow) {
      this.$parent.setCurrentSlideshow(slideshow)
      this.$parent.setSelectedPane('editor')
    },

    getUserSlideshows: function () {
      this.axios.get('/api/slideshow/' + PS.user.organization_id).then((response) => {
        if (response.data !== undefined) {
          this.slideshows = response.data
        } else {
          this.slideshows = []
        }
      }).catch((errors) => {
        localStorage.clear()
        // this.$router.push('/login')
      })
    },

    newSlideshow: function () {
      this.$parent.setCurrentSlideshow({})
      this.$parent.setSelectedPane('editor')
    }
  },

  props: ['refresh'],

  watch: {
    refresh: function () {
      // TODO: Prevent this from firing twice on intial page load
      this.getUserSlideshows()
      this.$parent.refreshSlideshowList = false
    }
  }
}
</script>

<style scoped>
  .collection {
    background: rgb(48, 48, 48);
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    border-radius: 6px 6px 0px 0px;
    cursor: pointer;
    height: 162px;
    width: 288px;
  }

  .collection-container {
    background: white;
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.2);
    border-radius: 6px;
    display: inline-block;
    justify-content: space-around;
    margin: 1em;
    transition: all 0.25s ease-out;
    vertical-align: top;
    width: 288px;
  }

  .collection-container:hover {
    transform: scale(1.1);
  }

  .collection-title {
    color: var(--dashboard-text);
    display: inline-block;
    padding: .75em;
    text-align: left;
  }

  .collection-actions {
    color: var(--dashboard-text);
    float: right;
    position: relative;
    text-align: right;
  }

  .new-slideshow {
    border: 3px dashed var(--med-grey);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    height: 208px;
    justify-content: space-around;
    margin: 1em;
    position: relative;
    transition: all 0.25s ease-out;
    width: 288px;
  }

  .new-slideshow:hover {
    background: white;
    border: solid var(--secondary);
    transform: scale(1.1);
  }

  .new-slideshow-title {
    color: var(--med-grey);
    font-size: 1.5em;
    font-weight: 500;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>
